<template>
<div>
      <v-card>
        <v-container style="padding-top:0px;padding-bottom:0px">
          <v-form>         
            <v-autocomplete :filter="filterObject" v-if="newCustomer!=customer&&!this.isEdit"  @change="(cstmr) => customerSeleted(cstmr)" :loading="isLoading"  v-model="customer.name" dense label="Search" :items="allCustomers"
            return-object
            item-text="id"
            item-value="value">
              <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                    <v-list-item-subtitle v-text="item.contactNumber"></v-list-item-subtitle> 
                    <v-list-item-subtitle v-text="item.address"></v-list-item-subtitle>
                    <v-list-item-subtitle v-text="item.postCode"></v-list-item-subtitle>
                    </v-list-item-content>
              </template>
            </v-autocomplete> 
            
            <v-text-field reeq disabled label="Customer Id" :value="customer.id" dense >
            </v-text-field>
            <v-text-field  v-if="newCustomer==customer||this.isEdit" label="Customer Name"  v-model="customer.name" dense>
            </v-text-field>                        

            <v-text-field label="Name" :disabled="!canEditFields()" v-model="customer.name" dense > </v-text-field>        
            <v-text-field label="Address" :disabled="!canEditFields()" v-model="customer.address" dense > </v-text-field>        
            
            <v-autocomplete :disabled="!canEditFields()"  @change="(cty) => citySeleted(cty)" :loading="isLoading" :search-input.sync="search" v-model="city.name" dense label="City" :items="allCities" 
            return-object
            item-text="name"
            item-value="value">
                <template v-slot:no-data>
                  <v-progress-circular v-if="loadingCity" indeterminate></v-progress-circular>
                      <a v-if="!loadingCity" @click="createNewCity()">Add this city</a>
                </template>                  
            </v-autocomplete>
            <v-text-field dense :disabled="!canEditFields()"  name="postcode" id="postcode" v-model="customer.postCode" label="Post Code">                 
            </v-text-field>
            <v-text-field dense :disabled="!canEditFields()"  name="contact" id="contact" v-model="customer.contactNumber" label="Contact No">                 
            </v-text-field>
            <v-text-field dense :disabled="!canEditFields()"   name="email" id="email" v-model="customer.email" label="Email">                 
            </v-text-field>
          </v-form>
          <v-card-actions class="action-box"> 
            
            <v-row align="center" justify="end">            
            <v-btn class="action-btn" @click="updateUser" v-if="(canModifyInvoice || canCreateInvoice || isAdmin || isCustomerOnly) && !isNewCustomer()&&this.customer.id!=null&&!isEdit" type="submit">Update</v-btn>
            <v-btn class="action-btn primary white--text" @click="saveUser" v-if="(canModifyInvoice || canCreateInvoice || isAdmin || isCustomerOnly) && (isNewCustomer()||isEdit)" type="submit">Save Customer</v-btn>
            <v-btn class="action-btn" @click="createNewCustomer" type="submit" v-if="(canModifyInvoice || canCreateInvoice || isAdmin || isCustomerOnly) && this.newCustomer!=this.customer">New user</v-btn>
            <v-btn class="action-btn" @click="cancelNewCustomer" type="submit" v-if="this.newCustomer==this.customer" >Cancel</v-btn>
            </v-row>
          </v-card-actions>
  
        </v-container>

        <v-progress-linear indeterminate v-if="sending"></v-progress-linear>
        
      </v-card>

      <v-snackbar v-model="userSaved" color="success">The user {{ lastUser }} was saved with success!</v-snackbar>
    
    <v-snackbar :timeout="snackBarDuration" v-model="showSnackbar" color="success" top>
      Customer has been created
    </v-snackbar>    
      <v-alert v-if="showAlert" type="error"> {{alertMessage}} </v-alert>
</div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { mapActions, mapState } from 'vuex'
  
  import {
    required,
    email,
    minLength,
    maxLength
  } from 'vuelidate/lib/validators'

  export default {
    name: 'customer-panel',
    computed: {
      ...mapState('invoice', ['selectedInvoice']),
    
      ...mapState('customers', ['selectedCustomer']),
      isAdmin () { return this.$store.getters['account/isAdmin'] },
      canCreateInvoice () { return this.$store.getters['account/canCreateInvoice'] },
      canModifyInvoice () { return this.$store.getters['account/canModifyInvoice'] },
      isCustomerOnly () { return this.$store.getters['account/isCustomerOnly'] }
    },
    mixins: [validationMixin],
    data: () => ({     
      newCustomer: {
        id: 'New',
        name: null,
        address: null,        
        age: null,
        email: null,
        zipCode: null
      },
      customer:{
        name: null,
        address: null,        
        age: null,
        email: null,
        zipCode: null
      },
       
      city:{
        name:null
      },
      isEdit: false,
      snackBarDuration: 2000,
      showSnackbar: false,        
      loadingCity: false,
      showAlert: false,
      alertMessage: null,
      cities: [],      
      agent: null,
      agents: [],
      allCustomers: [],
      allCities: [],
      customers: [],
      
      userSaved: false,
      sending: false,
      lastUser: null,
      search: null,
      searchCustomer: null,
      isLoading:false,
    }),
    validations: {
      form: {
        firstName: {
          required,
          minLength: minLength(3)
        },
        lastName: {
          required,
          minLength: minLength(3)
        },
        age: {
          required,
          maxLength: maxLength(3)
        },
        gender: {
          required
        },
        email: {
          required,
          email
        }
      }
    },
    created () {
      let self = this
      self.selectCustomer(null)
      this.getAll().then(customers => {        
        self.allCustomers = customers.filter(customer => customer.type.toLowerCase()=="customer");        
      })
      this.getAllCities().then(cities => {
        self.allCities = JSON.parse(JSON.stringify(cities))
      })
    },
     watch: {       
       selectedInvoice(newValue, oldValue) {
         console.log(oldValue)
         if (newValue.customer) {
          this.customer = JSON.parse(JSON.stringify(newValue))["customer"]
          this.city = JSON.parse(JSON.stringify(newValue))["customer"]["city"]
         }         
         console.log(this.city)
       },
        search (searchTerm) {          
          if (!searchTerm || searchTerm.length < 3) {
            console.log(this.cities);
          } else {
            const term = searchTerm.toLowerCase()
            let filterd = this.allCities.filter(({ name }) => name.toLowerCase().includes(term))
            this.cities = filterd
            console.log(this.cities);            
          }        
        },
        // searchCustomer (searchTerm) {          
        //   if (!searchTerm || searchTerm.length < 3) {
        //     console.log(this.cities);
        //   } else {

        //     // this.allCustomers.forEach(customer => {
        //     //   if (customer.contactNumber=="07886261687") {
        //     //     console.log(customer)
        //     //   }
        //     // });

        //     // const term = searchTerm.toLowerCase()            
        //     let filterd = this.allCustomers.filter(({ contactNumber}) => contactNumber==="07886261687")
        //     console.log(filterd)
        //     this.customers = filterd
        //   }        
        // },
        
      }
    ,
    methods: {
      ...mapActions('customers', ['getAll', 'addNewCustomer', 'updateCustomer', 'selectCustomer']),
      ...mapActions('geo', ['getAllCities', 'addNewCity']),
            filterObject(item, queryText) {
        const q = (queryText || '').toLocaleLowerCase();
        const contact  = (item.contactNumber  || '').toLocaleLowerCase();
        const postCode = (item.postCode       || '').toLocaleLowerCase();
        const address  = (item.address        || '').toLocaleLowerCase();
        const name     = (item.name           || '').toLocaleLowerCase();
        const mobile   = (item.mobileNumber   || '').toLocaleLowerCase();
        const email    = (item.email          || '').toLocaleLowerCase();
        const surname  = (item.surname        || '').toLocaleLowerCase();
        return (
          contact.includes(q)  ||
          postCode.includes(q) ||
          address.includes(q)  ||
          name.includes(q)     ||
          mobile.includes(q)   ||
          email.includes(q)    ||
          surname.includes(q)
        );
      },
      getValidationClass (fieldName) {
        const field = this.$v.form[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      createNewCustomer () {        
            this.customer = this.newCustomer
      },
      createNewCity () {
        let self = this
        self.loadingCity = true
        this.addNewCity(this.newCustomer.city.name).then(resp => {
          self.newCustomer.city = resp
          self.form.city = resp
          this.getAllCities().then(cities => {
            self.allCities = JSON.parse(JSON.stringify(cities))
            self.loadingCity = false
          })
        })
      },
      canEditFields(){
        return (this.isEdit||this.isNewCustomer())
      },
      isNewCustomer(){
        return this.customer.id=="New";
      },
      customerSeleted (customer ) {
        this.customer = JSON.parse(JSON.stringify(customer))
        this.city = JSON.parse(JSON.stringify(customer))["city"]
        this.selectCustomer(JSON.parse(JSON.stringify(customer)));
      },
      
      citySeleted (city) {
        this.city = city
      },
      clearForm () {
        this.form = {
          id: null,
          name: null,
          address: null,
          city: {name: null},
          age: null,
          email: null,
          zipCode: null
        }
        this.newCustomer = {
          id: 'New',
          name: null,
          address: null,
          city: {name: null},
          age: null,
          email: null,
          zipCode: null
        }
      },
       cancelNewCustomer () {
        this.customer= { name: null,
        address: null,
        city: {name: null},
        age: null,
        email: null,
        zipCode: null}
      },
      saveUser () {
        console.log(this.customer)
        if (!this.customer.name || !this.customer.contactNumber) {                    
          this.showAlert = true
          this.alertMessage = 'Please set customer name and contact number'
        } 
        else {
          this.showAlert = false
          let self = this
          this.customer['city'] = this.city
          
          if (this.isEdit) {
            this.isEdit=false
            this.updateCustomer(this.customer).then(customer => {
                self.customerSeleted(customer)
                self.allCustomers.push(customer)
                this.showSnackbar = true
            }).catch(error => {
                self.showAlert = true
                self.alertMessage = typeof error === 'string' ? error : (error.message || 'Error updating customer')
            })
          }
          else {
              delete this.customer['id'];
              this.addNewCustomer(this.customer).then(customer => {
                self.customerSeleted(customer)
                self.allCustomers.push(customer)
                this.showSnackbar = true
              }).catch(error => {
                self.showAlert = true
                self.alertMessage = typeof error === 'string' ? error : (error.message || 'Error creating customer')
              })
          }                 
        }
      },
      updateUser () {        
        this.isEdit=true
      },
      validateUser () {
        this.$v.$touch()

        if (!this.$v.$invalid) {
          this.saveUser()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .md-progress-bar {
    position: absolute;    
    right: 0;
    left: 0;
  }

  .v-text-field  {
    padding-top:-2px;
    margin-top:-2px;
  }

  .agent-combo {         
    width:150px;    
  }

  .action-box {         
   padding: 0px;
  }
  
  .action-btn { 
   padding-top:-5px;        
   margin-left:5px;
  }

  
  
</style>